import * as yup from 'yup';
import { AssetDTO, BucketDTO } from './api/useAssetBucketingDetailsQuery';

export interface FormValues {
  headline: string;
  supportingText: string;
  buckets: BucketDTO[];
  unassignedAssets: AssetDTO[];
}

export type RemoveAssetFn = ({
  assetId,
  bucketIndex,
}: {
  assetId: string;
  bucketIndex: number;
}) => void;

export const EMPTY_BUCKET: BucketDTO = {
  title: '',
  description: '',
  assets: [],
};

export const UNASSIGNED_BUCKET_INDEX = -1;

const bucketValidation = yup
  .object()
  .shape({
    title: yup
      .string()
      .nullable()
      .required('Please enter a Bucket Name'),

    description: yup
      .string()
      .nullable()
      .required('Please enter a Bucket Description'),
  })
  .test('unique-title', 'Please enter a unique bucket name', function uniqueTitle(bucket) {
    if ((this.parent as BucketDTO[]).filter(({ title }) => title === bucket.title).length > 1) {
      throw this.createError({ path: `${this.path}.title` });
    }

    return true;
  });

export const validation = yup.object().shape({
  headline: yup
    .string()
    .nullable()
    .required('Please enter a Headline'),

  supportingText: yup
    .string()
    .nullable()
    .required('Please enter a Supporting text'),

  buckets: yup.array().of(bucketValidation),
});
